module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }